import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getMemberInfo } from "@/hooks/useMembers";
import {
  setAmplitudeUser,
  setAmplitudeContext,
  trackEvent,
  identifyAmplitudeUser,
} from "@/utils/amplitude";

export const useAppAnalytics = () => {
  const memberInfo = getMemberInfo();
  const location = useLocation();

  // Identify user and set global analytics context (memberId, onBehalf)
  useEffect(() => {
    let memberId: string | undefined;
    let selectedMemberId: string | undefined;

    try {
      const stored = localStorage.getItem("member");
      if (stored) {
        const parsed = JSON.parse(stored);
        memberId = parsed?.id || parsed?._id || undefined;
      }

      const selectedStored = localStorage.getItem("selectedMember");
      if (selectedStored) {
        const parsedSelected = JSON.parse(selectedStored);
        selectedMemberId =
          parsedSelected?.id || parsedSelected?._id || undefined;
      }
    } catch {
      // ignore JSON/localStorage errors
    }

    const onBehalf =
      (memberInfo as any)?.onBehalf ?? (memberInfo as any)?.on_behalf;

    if (memberId) {
      setAmplitudeUser(memberId);
    }

    setAmplitudeContext({
      memberId,
      onBehalf: Boolean(onBehalf),
      selectedMemberId,
    });

    // Send the Traits
    identifyAmplitudeUser({
      memberId,
      onBehalf: Boolean(onBehalf),
      selectedMemberId,
    });
  }, [memberInfo]);

  useEffect(() => {
    const path = location.pathname || "/";
    trackEvent(`Viewed "${path}" Page`, { path });
  }, [location.pathname]);
};
